import React from 'react';
import { GasV3Integration as BaseGasV3Integration } from '@atlassian/commerce-events-telemetry-react/gasv3-bridge';
import { MetalIntegration as BaseMetalIntegration } from '@atlassian/commerce-events-telemetry-react/metal-bridge';
import { SentryBrowserIntegration as BaseSentryBrowserIntegration } from '@atlassian/commerce-events-telemetry-react/sentry-browser-bridge';
import { GasV3OperationalEventListener, GasV3ScreenEventListener, GasV3TrackEventListener, GasV3UIEventListener, MetalListener, SentryExceptionListener } from '../listeners';
export var GasV3Integration = function GasV3Integration(_ref) {
  var children = _ref.children,
      client = _ref.client;
  return /*#__PURE__*/React.createElement(BaseGasV3Integration, {
    client: client,
    GasV3OperationalEventListener: GasV3OperationalEventListener,
    GasV3ScreenEventListener: GasV3ScreenEventListener,
    GasV3TrackEventListener: GasV3TrackEventListener,
    GasV3UIEventListener: GasV3UIEventListener
  }, children);
};
export var MetalIntegration = function MetalIntegration(_ref2) {
  var children = _ref2.children,
      client = _ref2.client;
  return /*#__PURE__*/React.createElement(BaseMetalIntegration, {
    client: client,
    Listener: MetalListener
  }, children);
};
export var SentryBrowserIntegration = function SentryBrowserIntegration(_ref3) {
  var children = _ref3.children,
      client = _ref3.client;
  return /*#__PURE__*/React.createElement(BaseSentryBrowserIntegration, {
    client: client,
    Listener: SentryExceptionListener
  }, children);
};